import {
  Text as BlueprintText,
  TextProps as BlueprintTextProps,
} from '@blueprintjs/core';
import * as React from 'react';

export interface TextProps extends BlueprintTextProps {
  children?: React.ReactNode;
}

export const Text: React.VFC<TextProps> = ({ children, ...textProps }) => (
  <div className="sd-text" data-heap-redact-attributes="title">
    <BlueprintText
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...textProps}
    >
      {children}
    </BlueprintText>
  </div>
);
